import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { type Position } from "./entity";
import { preProcessFilterPerRoles } from "@shared/backend/entity-security/preprocess-filter-for-role";

export const PositionEntityConfig: HyperEntityConfig<Position> = {
    allowApiCrud: false
};
